import React from "react";
import logo from "../../assets/images/fuloos_logo.svg";

function AuthLeft() {
  return (
    <div className="col-lg-6 d-none d-lg-flex justify-content-center">
      <div>
        <div className="text-center mb-3">
          {/* <img src={logo} style={{ width: "260px" }} alt="logo"/> */}
        </div>
      </div>
    </div>
  );
}
export default AuthLeft;
